<template>
  <div class="azienda">
    <common-hero :background="pageApiData.cover" :tag="'div'">
      <span class="common-hero__processing-order">{{ pageApiData.title }}</span>
      <h1>{{ pageApiData.description }}</h1>
    </common-hero>
    <section class="paragrafo-blocco paragrafo-blocco--sfondo">
      <div
        v-html="pageApiData.descriptionMission"
        class="default-container"></div>
    </section>
    <section class="paragrafo-bianco" style="padding-bottom:40px;">
      <div
        v-html="pageApiData.descriptionStoria"
        v-animate-on-intersection
        class="default-container"></div>
    </section>
    <section class="lavorazioni-sub-tech-details lavorazioni-sub-tech-details--white">
      <zmm-gallery :gallery-id="pageApiData.gallery" :lang="lang"/>
    </section>
    <section class="paragrafo-blocco paragrafo-blocco--sfondo">
      <div
        v-html="pageApiData.descriptionVision"
        class="default-container"></div>
    </section>
    <section class="paragrafo-bianco" style="padding-bottom:40px;">
      <div v-html="pageApiData.descriptionPolitical"
        v-animate-on-intersection
        class="default-container"></div>

        <!-- Loghi -->
        <div class="default-container">
          <div class="azienda__certifications">
            <!-- Logo -->
            <div class="azienda__certification">
              <img src="/azienda/ico-iso9001.svg" alt="Iso 9001" />
              <a :href="$i18n.locale === 'en' ? '/azienda/PDF/ISO_9001-ENG-214523-2017-AQ-ITA-ACCREDIA-5-20250603.pdf' : '/azienda/PDF/ISO_9001-ITA-214523-2017-AQ-ITA-ACCREDIA-5-20250603.pdf'" class="azienda__certification__link">Download</a>
            </div>
            <!-- Logo -->
            <div class="azienda__certification">
              <img src="/azienda/ico-iso14001.svg" alt="Iso 14001" />
              <a :href="$i18n.locale === 'en' ? '/azienda/PDF/ISO_14001-ENG-251835-2017-AE-ITA-ACCREDIA-3-20250604.pdf' : '/azienda/PDF/ISO_14001-ITA-251835-2017-AE-ITA-ACCREDIA-3-20250604.pdf'" class="azienda__certification__link">Download</a>
            </div>
          </div>

        </div>

    </section>
    <section class="paragrafo-bianco paragrafo-bianco--download">
      <div class="default-container">
        <h3 v-html="pageApiData.areaDownload"></h3>
        <div class="paragrafo-bianco__download-area">
          <ul>
            <li>
              <a href="/azienda/PDF/politica-ambientale-2025.pdf" target="_blank">
                <h4 v-html="pageApiData.areaDownloadFile1" />
                <span>Download PDF</span>
              </a>
            </li>
            <li>
              <a href="/azienda/PDF/politica-qualita-2025.pdf" target="_blank">
                <h4 v-html="pageApiData.areaDownloadFile2" />
                <span>Download PDF</span>
              </a>
            </li>
               <li>
              <a href="/azienda/PDF/codice-etico-2025.pdf" target="_blank">
                <h4 v-html="pageApiData.areaDownloadFile3" />
                <span>Download PDF</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import CommonHero from '@/components/CommonHero'
import ZmmGallery from '@/components/ZmmGallery'

export default {
  mixins: [ lang, dataLoad ],
  components: {
    CommonHero,
    ZmmGallery
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .azienda{
    background-color: #FFF;
  }

  .azienda_content{
    padding: 4rem 0;

    @media #{$xlarge_mq} {
        padding: 6rem 0;
      }
  }

  .azienda .servizi__section__content{

    p:nth-child(3){
      font-size: 1.6rem;
      line-height: 1.8;
      padding: 3rem 0;
      margin: 0;
      color: #4A4A4A;
      margin: 0;
      font-weight: 300 !important;

      @media #{$medium_mq} {
        margin-left: 5rem !important;
      }

      @media #{$xlarge_mq} {
        font-size: 2rem;
      }
    }
  }

.paragrafo-blocco{
  background: #1D1D1B;

  &.paragrafo-blocco--sfondo{
    background: #1D1D1B url('/home/sfondo-paragrafo.jpg') center center;
    background-size: cover;
  }
  padding: 90px 0;

  @media #{$medium_mq} {
    padding: 140px 0;
  }
  @media #{$large_mq} {
    padding: 180px 0;
  }
  @media #{$xlarge_mq} {
    padding: 210px 0;
  }
  @media #{$xxlarge_mq} {
    padding: 240px 0;
  }
  h3 {
    letter-spacing: .2rem;
    @include size-16-pixel(#EFEFF1);
    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 500;
    margin-bottom: 0;
  }
  h4 {
    @include section-title(#666666);
    br{
      display: none;
      @media #{$xlarge_mq} {
        display: block;
      }
    }
  }
}

.paragrafo-bianco {
  background-color: #FFF;
  padding: 100px 0;

  @media #{$medium_mq} {
    padding: 125px 0;
  }
  @media #{$large_mq} {
    padding: 145px 0;
  }
  @media #{$xlarge_mq} {
    padding: 165px 0;
  }
  @media #{$xxlarge_mq} {
    padding: 185px 0;
  }

  h3 {
    letter-spacing: .2rem;
    @include size-16-pixel(#4A4A4A);
    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 500;
    margin-bottom: 2.1rem;
  }
  h2 {
    @include section-paragraph($color: #4A4A4A);
    margin-bottom: 4rem;
  }

  p {
    font-family: 'Roboto';
    font-weight: 300;
    @include size-18-pixel(#4A4A4A);
    line-height: 1.8;
    margin-bottom: 2rem;
  }

  quote{
    @include block-quote($color: #4A4A4A);
    border-left: 14px solid #4A4A4A;
    display: block;
    margin: 5rem 0;
    padding: 6px 0 0 40px;
  }

  @media #{$large_mq} {
    h3, h2, p{
      width: 70%;
    }
  }

}

.paragrafo-bianco--download{
  padding: 60px 0 80px;
  @media #{$medium_mq} {
    padding: 80px 0 100px;
  }
  @media #{$large_mq} {
    padding: 90px 0 130px;
  }
  @media #{$xlarge_mq} {
    padding: 110px 0 150px;
  }
  @media #{$xxlarge_mq} {
    padding: 130px 0 170px;
  }
}

.lavorazioni-sub-tech-details.lavorazioni-sub-tech-details--white{
  padding-top: 0;
  background-color: #FFF;
  padding: 4rem 0 6rem;
  @media #{$medium_mq} {
    padding: 4rem 0 8rem;
  }
  @media #{$large_mq} {
    padding: 4rem 0 10rem;
  }
  @media #{$xlarge_mq} {
    padding: 4rem 0 11rem;
  }
  @media #{$xxlarge_mq} {
    padding: 4rem 0 12rem;
  }

  .zmm-gallery__arrows__prev .svg-arrow{
    stroke: #EFEFF1;
    transition: color 400 linear;
  }
  .zmm-gallery__arrows__next .svg-arrow{
    stroke: #4A4A4A;
    transition: color 400 linear;
  }

  .zmm-gallery__arrows__prev:hover .svg-arrow{
    stroke: #679196;
  }
  .zmm-gallery__arrows__next:hover .svg-arrow{
    stroke: #679196;
  }
}

.paragrafo-bianco__download-area{
  ul{
    display: flex;
    flex-wrap: wrap;
    margin: 4rem 0 0 0; padding: 0;
    list-style: none; list-style-type: none;
    li{
      margin-right: 4rem;
      margin-bottom: 3rem;
      a{
        display: block;
        width: 320px; height: 260px;
        background-color: #1D1D1B;
        text-decoration: none;
        padding: 30px 35px;

        span::before{
          height: 4px;
        }

        &:hover{
          span::before{
            height: 100%;
          }
        }
      }
      h4{
        font-size: 2rem;
        line-height: 1.25;
        letter-spacing: .1rem;

        color: #9B9B9B;
        font-family: 'Sectra', sans-serif;
        font-weight: 400;
        text-transform: uppercase;
        letter-spacing: 0;

        @media #{$xlarge_mq} {
          font-size: 2.15rem;
          line-height: 1.35;
        }
        @media #{$xxlarge_mq} {
          font-size: 2.25rem;
        }

        margin: 0;
      }
      span{
        @include link-triangle-effect($color: #EFEFF1);
        position: absolute;
        left: 0; bottom: 0; width: 100%;
        padding: 30px 0 30px 35px;
        &::after{
          background-image: url("data:image/svg+xml,%3Csvg width='12px' height='11px' viewBox='0 0 12 11' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='DESKTOP' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='12-AZIENDA' transform='translate(-443.000000, -6036.000000)' fill='%23EFEFF1' fill-rule='nonzero'%3E%3Cg id='Group-2' transform='translate(267.000000, 5754.000000)'%3E%3Cpath d='M185.337618,287.488 L177.869751,283.504 L177.869751,291.472 L185.337618,287.488 Z M177,282 L187.287061,287.488 L177,292.976 L177,282 Z' id='3' transform='translate(182.143530, 287.488000) rotate(-270.000000) translate(-182.143530, -287.488000) '%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
          left: 185px; right: auto;
          bottom: 34px; top: auto;
        }
      }
    }
  }
}

.azienda__certifications{
  display: flex;
  // justify-content: center;
  gap: 36px;
  width: 100%;
  @media #{$medium_mq} {
    justify-content: start;
  }
}

.azienda__certification{
  max-width: 110px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;

  @media #{$medium_mq} {
    max-width: 150px;
  }
  img{
    display: inline-block;
    width: 100%;
    height: auto;
  }
}

.azienda__certification__link{
  font-size: 0.8rem;
  text-transform: uppercase;
  color: #000;
  margin: auto;
  line-height: 1.5;
  text-decoration: none;
  transition: all .4s linear;
  border-bottom: 1px solid #fff;

  &:hover{
    border-bottom: 1px solid #000000;
  }

  &::after{
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    border-top: 5px solid #000;
    right: -10px;
    top: 8px;

    @media #{$xlarge_mq} {
      top: 8px;
    }
  }
}

</style>
